export enum SmsAuthErrorCode {
  TooManyAttempts = "SMS_AUTH_TOO_MANY_ATTEMPTS",
  InvalidCode = "SMS_AUTH_INVALID_CODE",
  NoAttempts = "SMS_AUTH_NO_ATTEMPTS",
  InvalidStatus = "SMS_AUTH_INVALID_STATUS",
  Disabled = "SMS_AUTH_DISABLED",
  DdosBlocked = "SMS_AUTH_DDOS_BLOCKED"
}
